export const UC_EVENT_NAME = 'ucEvent';
export const UC_INITIALIZED_EVENT = 'UC_UI_INITIALIZED';

export const UC_INITIAL_PAGE_LOAD_ACTION = 'onInitialPageLoad';

export enum UCConsentServiceNames {
    Relewise = 'Relewise',
    Sprii = 'Sprii'
}
